import React, { FC, useCallback, useState } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvFlexColumn,
	EvFlexRow,
	EvTable,
	SORT_ORDER
} from '@evinced-private/ui-common';

import {
	LABEL_MANAGEMENT_CREATE_BUTTON_DAID,
	LABEL_MANAGEMENT_TABLE_DAID
} from 'data-automation-ids/LabelManagementAutomationIds';

import { Label } from '../../types';

import { ValuesModal } from './cells';
import { CREATE_BUTTON_COLUMN_WIDTH, LABELS_TABLE_ID } from './LabelsTable.constants';
import { LABELS_TABLE_LABELS } from './LabelsTable.labels';
import { ActiveValuesModal, LabelsTableProps } from './LabelsTable.types';
import { getLabelsTableColumns } from './LabelsTable.utils';

import './LabelsTable.scss';

export const LabelsTable: FC<LabelsTableProps> = ({ labels, onEdit, onCreateLabel }) => {
	const [activeValuesModal, setActiveValuesModal] = useState<ActiveValuesModal | null>(null);

	const handleShowMore = useCallback((label: Label) => {
		setActiveValuesModal({ labelKey: label.key, values: label.values });
	}, []);

	const handleCloseModal = useCallback(() => {
		setActiveValuesModal(null);
	}, []);

	const columns = getLabelsTableColumns(onEdit, handleShowMore);

	return (
		<EvFlexColumn gap="XLARGE">
			<EvFlexRow justify="END">
				<EvFlexColumn width={CREATE_BUTTON_COLUMN_WIDTH}>
					<EvButton
						type={BUTTON_TYPES.PRIMARY}
						title={LABELS_TABLE_LABELS.CREATE_BUTTON}
						dataAutomationId={LABEL_MANAGEMENT_CREATE_BUTTON_DAID}
						onClick={onCreateLabel}
						isFullWidth
					>
						+{LABELS_TABLE_LABELS.CREATE_BUTTON}
					</EvButton>
				</EvFlexColumn>
			</EvFlexRow>
			<EvTable
				dataAutomationId={LABEL_MANAGEMENT_TABLE_DAID}
				tableData={labels}
				totalCount={labels.length}
				showInfoRow={false}
				columns={columns}
				noDataIndicationMessage={LABELS_TABLE_LABELS.EMPTY_STATE}
				options={{
					keyField: 'key',
					title: LABELS_TABLE_LABELS.TABLE_TITLE,
					caption: LABELS_TABLE_LABELS.TABLE_CAPTION,
					dataType: LABELS_TABLE_ID,
					defaultSorted: [{ dataField: 'key', order: SORT_ORDER.ASC }]
				}}
			/>
			{activeValuesModal && (
				<ValuesModal
					isOpen
					labelKey={activeValuesModal.labelKey}
					values={activeValuesModal.values}
					onClose={handleCloseModal}
				/>
			)}
		</EvFlexColumn>
	);
};
